import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import OccasionPage from "./pages/OccasionPage";
import BlogListPage from "./pages/BlogListPage";
import BlogPostPage from "./pages/BlogPostPage";
import LocationPage from "./pages/LocationPage";
import FloatingCallButton from "./components/FloatingCallButton";
import SeasonalFlowersPage from "./pages/SeasonalFlowersPage";
import BirthFlowersPage from "./pages/BirthFlowersPage";
import { initShopClickTracking } from "./lib/analytics";

// Sends a page_view to Google Analytics on every client-side route change
function AnalyticsTracker() {
  const location = useLocation();
  useEffect(() => {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("config", "G-2JV964BJS4", {
        page_path: location.pathname + location.search,
        page_title: document.title,
      });
    }
  }, [location]);
  return null;
}

function App() {
  useEffect(() => initShopClickTracking(), []);

  return (
    <div className="App">
      <BrowserRouter>
        <AnalyticsTracker />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/occasions/:slug" element={<OccasionPage />} />
            <Route path="/blog" element={<BlogListPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/flower-delivery/:slug" element={<LocationPage />} />
            <Route path="/seasonal-flowers" element={<SeasonalFlowersPage />} />
            <Route path="/birth-flowers" element={<BirthFlowersPage />} />
          </Routes>
        </main>
        <Footer />
        <FloatingCallButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
